import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";

import { formValueSelector, Field, Fields, change } from "redux-form";
import api from "APP_ROOT/api";
import {
  AutoCompleteField,
  form,
  Form as AppForm,
  FormInput,
  Select,
  TextArea
} from "MODULES/shared/components/Forms/index";
import Total from "MODULES/OutgoingQuotes/shared/Total";
import PartDetails, {
  copyFromInventoryFields
} from "MODULES/OutgoingQuotes/shared/PartDetails";
import OutgoingQuoteTypeSelect from "MODULES/OutgoingQuotes/shared/OutgoingQuoteTypeSelect";
import warnings from "MODULES/OutgoingQuotes/shared/warnings";
import { LineItemsTable } from "MODULES/parts/components/Detail/OutgoingQuotes/LineItemsTable";
import { isLessThan36HoursAgo } from "LIB/time";
import {
  searchOutgoingQuoteLineItems,
  searchParts
} from "MODULES/parts/actions/index";
import {
  CONDITION,
  DO_NOT_LIST,
  EASA,
  FAA,
  LIST,
  OVERHAULED,
  PART_ID,
  REPAIRED,
  SERIAL_NUMBER,
  TAG_DATE,
  TAGGED_BY,
  TRACE_TYPE,
  TRACED_TO
} from "MODULES/inventories/constants";
import SelectInventoryTable from "MODULES/OutgoingQuotes/shared/SelectInventoryTable";
import {
  AS_IS,
  EXCHANGE_FEE,
  EXCHANGE_ONLY,
  FOLLOW_UP_FEEDBACK,
  INVENTORY_IDS,
  NO_INTEREST,
  NO_QUOTE,
  OUTGOING_LINE_ITEMS,
  PRICE_PER_UNIT,
  QUOTE_TYPE,
  SELL_AS_ALT_ID,
  WARRANTY
} from "MODULES/OutgoingQuotes/constants";
import {
  NoPmaNoDerWarning,
  TraceTypeWarning,
  StrictTraceWarning,
  WarrantyMinimumWarning
} from "MODULES/SalesOrders/components/ConvertFromCartForm/Warnings";
import { BEYOND_ECON_REPAIR } from "MODULES/Receiving/constants";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import {
  CAN_EXCHANGE,
  COMPANY_ID,
  DEFAULT_HAZMAT_FEE,
  INVENTORY_ID,
  QUANTITY,
  SETTINGS
} from "APP_ROOT/constants";
import {
  COMPANY,
  EXTERNAL_NOTE,
  HAZMAT_FEE,
  INTERNAL_NOTE
} from "MODULES/PurchaseOrders/constants";
import { Col } from "react-bootstrap";
import { handleRepairItem } from "MODULES/OutgoingQuotes/shared/helpers";
import { OTHER } from "MODULES/shared/constants";
import { OFFER } from "MODULES/IncomingQuotes/constants";
import { Table as SalesOrdersTable } from "MODULES/parts/components/Detail/SalesOrders/Table";
import { properCase } from "LIB/formatters/text";
import PartHazmatWarning from "MODULES/parts/components/shared/PartHazmatWarning";
import { DO_NOT_EXCHANGE } from "MODULES/companies/constants";
import DoNotExchangeWarning from "MODULES/companies/shared/components/DoNotExchangeWarning";
import { decimalField } from "LIB/formatters/number";
import {
  HAZMAT,
  PERMANENT_EXTERNAL_NOTE_FOR_OQ
} from "MODULES/parts/constants";
import { CORE_DUE_DAYS } from "MODULES/RepairOrders/constants";
import RestrictedEntityWarning from "MODULES/companies/shared/components/RestrictedEntityWarning";
import validate from "./validate";

const formName = "partDetailNewOutgoingQuote";

export class Form extends Component {
  static propTypes = {
    getFieldValue: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pricePerUnit: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    quoteType: PropTypes.string,
    quoteTypes: PropTypes.instanceOf(Object),
    searchParts: PropTypes.func.isRequired,
    searchOutgoingQuoteLineItems: PropTypes.func.isRequired,
    change: PropTypes.func,
    companyId: PropTypes.number,
    inventoryIds: PropTypes.arrayOf(PropTypes.number)
  };

  state = {
    contacts: [],
    companyPartHistory: {},
    outgoingQuotes: [],
    quantityChanged: false,
    inventoryPrice: null,
    recentSOs: [],
    selectedInventories: [],
    selectedPart: null
  };

  setWarrantyField = val => {
    this.props.change(WARRANTY, val);
  };

  getInventoriesFilter() {
    const { quoteType } = this.props;

    const inventoriesFilter = {
      limit: "10",
      sellable_status: [LIST, DO_NOT_LIST].join(",")
    };

    if (quoteType === OFFER) {
      inventoriesFilter.or_in_condition = BEYOND_ECON_REPAIR;
    }

    return inventoriesFilter;
  }

  copyInventoryFields = inventory =>
    Object.keys(copyFromInventoryFields).forEach(field =>
      this.props.change(
        field,
        copyFromInventoryFields[field](
          inventory,
          this.props.quoteType,
          this.state.selectedPart,
          this.props.canExchange &&
            !this.props.quote.getIn([COMPANY, DO_NOT_EXCHANGE])
        )
      )
    );

  clearFieldsCopiedFromInventory = () => {
    Object.keys(copyFromInventoryFields).forEach(field => {
      if (field === WARRANTY && this.props.quoteType === AS_IS) {
        this.props.change(field, "No Warranty, unit sold as-is.");
      } else {
        this.props.change(field, null);
      }
    });

    [FAA, EASA].forEach(f => this.props.change(f, true));
  };

  handleInventorySelected = inventory => {
    const { inventoryIds } = this.props;
    const { selectedInventories } = this.state;
    if (inventory === null) {
      this.props.change(INVENTORY_IDS, []);
      this.props.change(INVENTORY_ID, null);
      this.clearFieldsCopiedFromInventory();
      return;
    }

    if (inventoryIds.includes(inventory.id)) {
      const index = inventoryIds.indexOf(inventory.id);
      this.setState({
        selectedInventories: selectedInventories.filter(
          i => i.id !== inventory.id
        )
      });
      inventoryIds.splice(index, 1);
      this.props.change(INVENTORY_IDS, inventoryIds);
    } else {
      inventoryIds.push(inventory.id);
      this.setState({
        selectedInventories: selectedInventories.concat([inventory])
      });
      this.props.change(INVENTORY_IDS, inventoryIds);
      if (this.state.inventory !== inventory && inventoryIds.length === 1) {
        this.copyInventoryFields(inventory);
        api.inventories.show(inventory.id).then(res => {
          handleRepairItem({
            change: this.props.change,
            inventoryDetails: res.data,
            getNameFromSection: field => field
          });
        });
      }

      if (inventoryIds.length > 1) {
        this.clearFieldsCopiedFromInventory();
      }
    }
    this.setState({ quantityChanged: false });
    this.setState({ inventoryPrice: inventory && inventory.suggested_retail });
  };

  handlePartSelected = part => {
    this.setState({ selectedPart: part });
    if (part) {
      this.props.searchOutgoingQuoteLineItems(part.id).then(resp => {
        this.setState({ outgoingQuotes: resp });
      });

      api.companies.parts
        .history(this.props.companyId, [part.id])
        .then(({ data }) => {
          this.setState({
            companyPartHistory: data.results[0] || {}
          });
        });

      api.parts.salesOrderLineItems
        .search(part.id, { limit: 5 })
        .then(({ data: { results: recentSOs } }) => {
          this.setState({ recentSOs });
        });

      if (part.pass_fail) {
        this.props.change(EXCHANGE_FEE, "");
        if (
          [OVERHAULED, REPAIRED].includes(this.props.getFieldValue(CONDITION))
        ) {
          this.props.change(WARRANTY, "30 days");
        }
      }

      if (part.hazmat) {
        this.props.change(HAZMAT_FEE, this.props.defaultHazmatFee);
      }

      if (part[PERMANENT_EXTERNAL_NOTE_FOR_OQ]) {
        this.props.change(EXTERNAL_NOTE, part[PERMANENT_EXTERNAL_NOTE_FOR_OQ]);
      }
    }
  };

  handleQuantityChanged = () => {
    if (!this.state.quantityChanged) this.props.change(SERIAL_NUMBER, "");
    this.setState({ quantityChanged: true });
  };

  render() {
    const {
      canExchange,
      submitting,
      companyId,
      getFieldValue,
      setFieldValue,
      inventoryIds,
      quantity,
      pricePerUnit,
      quote,
      quoteType,
      quoteTypes = OUTGOING_LINE_ITEMS.quoteType
    } = this.props;

    const {
      companyPartHistory,
      outgoingQuotes,
      selectedPart,
      selectedInventories
    } = this.state;

    const mostRecentQuotes = outgoingQuotes.filter(
      q => isLessThan36HoursAgo(q.created_at) && companyId === q.company_id
    );

    const company = quote.get(COMPANY).toJS();
    const inventoriesFilter = this.getInventoriesFilter();
    const isBERMaterialSelected = _.some(
      selectedInventories,
      item => item.condition === BEYOND_ECON_REPAIR
    );
    const disablePartFields = {
      price_per_unit:
        isBERMaterialSelected && getFieldValue(OFFER) === NO_INTEREST,
      exchange_fee: isBERMaterialSelected || company[DO_NOT_EXCHANGE]
    };
    const altOptions = selectedPart
      ? selectedPart.alternates.map(a => ({
          value: a.id,
          text: a.name
        }))
      : [];

    return (
      <AppForm {...this.props} submitting={submitting}>
        <AppForm.Body>
          <NoPmaNoDerWarning
            company={company}
            inventories={selectedInventories}
          />
          <TraceTypeWarning
            company={company}
            inventories={selectedInventories}
          />
          <WarrantyMinimumWarning
            company={company}
            lineItems={[{ warranty: getFieldValue(WARRANTY) }]}
          />
          <StrictTraceWarning
            inventories={selectedInventories}
            company={company}
          />
          <DoNotExchangeWarning company={company} />
          <RestrictedEntityWarning company={company} />
          {warnings(mostRecentQuotes, companyPartHistory)}
          <div className="row">
            <Col md={8}>
              <div
                className="row row-col-gutters-half"
                style={{ marginTop: "26px" }}
              >
                <Col md={4}>
                  <Fields
                    names={[
                      CONDITION,
                      INVENTORY_ID,
                      PRICE_PER_UNIT,
                      QUANTITY,
                      TAGGED_BY,
                      TAG_DATE,
                      TRACE_TYPE,
                      TRACED_TO,
                      EXCHANGE_FEE,
                      WARRANTY
                    ]}
                    component={OutgoingQuoteTypeSelect}
                    quoteTypes={quoteTypes}
                  />
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <Field
                      autoFocus
                      name={PART_ID}
                      label="Part #"
                      placeholder="Type a part's name of ID number..."
                      component={AutoCompleteField}
                      search={this.props.searchParts}
                      formatItem={result => result && result.part_number}
                      selectedItem={selectedPart}
                      onItemSelected={i => i && this.handlePartSelected(i)}
                      required
                    />
                  </div>
                </Col>
                <Col md={4}>
                  <div className="form-group">
                    <Field
                      name={SELL_AS_ALT_ID}
                      component={Select}
                      label="Quote as Alt"
                      options={altOptions}
                    />
                  </div>
                </Col>
              </div>
              <hr className="hr-sm" />
              <h4>Select From Inventory</h4>
              <div className="form-group">
                <SelectInventoryTable
                  key={quoteType}
                  filter={inventoriesFilter}
                  part={selectedPart}
                  inventoryIds={inventoryIds}
                  onInventorySelected={this.handleInventorySelected}
                />
              </div>
              <hr className="hr-sm hr-dashed" />
              <h4>Most Recent Sales Orders</h4>
              <SalesOrdersTable results={this.state.recentSOs} disableRowNav />
              <hr className="hr-xs hr-dashed" />
              <h4>Most Recent Outgoing Quotes</h4>
              <LineItemsTable results={outgoingQuotes} disableRowNav />
              {quoteType !== NO_QUOTE && (
                <div>
                  <hr className="hr-sm" />
                  <h4>Part Details</h4>
                  <PartDetails
                    canExchange={canExchange}
                    formName={formName}
                    getFieldValue={getFieldValue}
                    setFieldValue={setFieldValue}
                    quoteType={quoteType}
                    setWarrantyField={this.setWarrantyField}
                    handleQuantityChanged={this.handleQuantityChanged}
                    inventoryIds={inventoryIds}
                    selectedInventories={selectedInventories}
                    passFail={selectedPart && selectedPart.pass_fail}
                    resetFields={() => {}}
                    part={selectedPart}
                    disabled={disablePartFields}
                  >
                    {_.get(selectedPart, HAZMAT) && [
                      <PartHazmatWarning
                        hazmat={selectedPart.hazmat}
                        hazmatFee={getFieldValue(HAZMAT_FEE)}
                      />,
                      <FormRow>
                        <Col md={4}>
                          <div className="form-group">
                            <Field
                              name={HAZMAT_FEE}
                              label={properCase(HAZMAT_FEE)}
                              component={FormInput}
                              type="number"
                              step={0.01}
                              onBlur={(ev, val) => {
                                ev.preventDefault();
                                setFieldValue(HAZMAT_FEE)(decimalField(val));
                              }}
                            />
                          </div>
                        </Col>
                        {quoteType === EXCHANGE_ONLY && (
                          <Col md={4}>
                            <Field
                              label={properCase(CORE_DUE_DAYS)}
                              name={CORE_DUE_DAYS}
                              type="number"
                              step={1}
                              component={FormInput}
                            />
                          </Col>
                        )}
                      </FormRow>
                    ]}
                    {!_.get(selectedPart, HAZMAT) &&
                      quoteType === EXCHANGE_ONLY && (
                        <FormRow>
                          <Col md={4}>
                            <Field
                              label={properCase(CORE_DUE_DAYS)}
                              name={CORE_DUE_DAYS}
                              type="number"
                              step={1}
                              component={FormInput}
                            />
                          </Col>
                        </FormRow>
                      )}
                  </PartDetails>
                </div>
              )}
              <hr className="hr-xs hr-dashed" />{" "}
              <div className="form-group">
                <FormRow>
                  <Col md={6}>
                    <Field
                      name={INTERNAL_NOTE}
                      rows={5}
                      cols={50}
                      required={getFieldValue(FOLLOW_UP_FEEDBACK) === OTHER}
                      component={TextArea}
                      label="Internal Note (Applied to the line item)"
                    />
                  </Col>
                  <Col md={6}>
                    <Field
                      name={EXTERNAL_NOTE}
                      rows={5}
                      cols={50}
                      component={TextArea}
                      label="External Note (*visible to Customer*)"
                    />
                  </Col>
                </FormRow>
              </div>{" "}
            </Col>{" "}
            <Col md={4}>
              {selectedPart && (
                <Total
                  part={selectedPart}
                  quantity={quantity}
                  pricePerUnit={pricePerUnit}
                />
              )}
            </Col>
          </div>{" "}
        </AppForm.Body>
      </AppForm>
    );
  }
}

const selector = formValueSelector(formName);

export default connect(
  state => ({
    canExchange: state.session.getIn([SETTINGS, CAN_EXCHANGE]),
    defaultHazmatFee: state.session.getIn([SETTINGS, DEFAULT_HAZMAT_FEE]),
    getFieldValue: field => selector(state, field),
    inventoryIds: selector(state, INVENTORY_IDS),
    quantity: selector(state, QUANTITY),
    pricePerUnit: selector(state, PRICE_PER_UNIT),
    quoteType: selector(state, QUOTE_TYPE),
    companyId: state.outgoingQuoteDetail.getIn(["outgoingQuote", COMPANY_ID])
  }),
  dispatch => ({
    searchParts: filter => dispatch(searchParts(filter)),
    setFieldValue: field => val => dispatch(change(formName, field, val)),
    searchOutgoingQuoteLineItems: partId =>
      dispatch(searchOutgoingQuoteLineItems(partId))
  })
)(
  form({
    form: formName,
    validate
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/LineItems/Create/Form.jsx